// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191205/js/" + chunkId + "." + {"44":"74742127","225":"311c9dc4","481":"1521a963","486":"f7454625","770":"e386d1e7"}[chunkId] + ".0.951822708592324.chunk.js";
};